<script setup lang="ts">
useSeoMeta({
  title: "Kontakt",
  ogTitle: "Kontakt"
})
</script>

<template>
  <main>

    <!-- Hero -->
    <div class="public-quiet-hero bg-zinc-900 py-20 px-6 text-center">
      <h1 class="text-4xl sm:text-5xl font-bold text-white mb-5">Wir sind für dich da</h1>
      <p class="text-stone-300 text-xl max-w-2xl mx-auto">
        Schreib uns oder ruf einfach an – ob Firmenveranstaltung, Hochzeit oder Vereinsfest, wir melden uns schnell zurück.
        <NuxtLink to="/about" class="inline-flex items-center gap-1 whitespace-nowrap text-[#4C9CD4] underline ml-1 hover:text-stone-300 transition-colors">
          Mehr über uns <i class="pi pi-arrow-right text-sm" aria-hidden="true"></i>
        </NuxtLink>
      </p>
    </div>

    <!-- Kontakt-Karten -->
    <div class="public-quiet-section bg-zinc-800 py-16 px-6">
      <div class="max-w-2xl mx-auto flex flex-col gap-4">
        <a href="tel:+436642247433" class="contact-card flex items-center gap-4 bg-zinc-900 rounded-xl p-5 no-underline group transition-colors">
          <div class="w-12 h-12 rounded-full bg-zinc-700 flex items-center justify-center flex-shrink-0">
            <i class="pi pi-phone text-xl text-[#E39737]"></i>
          </div>
          <div class="flex flex-col flex-1">
            <span class="text-stone-400 text-xs font-medium uppercase tracking-wide">Telefon</span>
            <span class="text-white font-medium text-lg">+43 (0) 664 / 22 474 33</span>
          </div>
          <i class="pi pi-arrow-right text-stone-500 group-hover:text-[#E39737] transition-all"></i>
        </a>

        <a href="mailto:info@mody.at" class="contact-card flex items-center gap-4 bg-zinc-900 rounded-xl p-5 no-underline group transition-colors">
          <div class="w-12 h-12 rounded-full bg-zinc-700 flex items-center justify-center flex-shrink-0">
            <i class="pi pi-envelope text-xl text-[#4C9CD4]"></i>
          </div>
          <div class="flex flex-col flex-1">
            <span class="text-stone-400 text-xs font-medium uppercase tracking-wide">E-Mail</span>
            <span class="text-white font-medium text-lg">info@mody.at</span>
          </div>
          <i class="pi pi-arrow-right text-stone-500 group-hover:text-[#4C9CD4] transition-all"></i>
        </a>
      </div>
    </div>

    <!-- CTA -->
    <div class="public-quiet-section bg-zinc-900 py-16 px-6 text-center">
      <h2 class="text-3xl font-bold text-white mb-4">Detaillierte Anfrage?</h2>
      <p class="text-stone-300 text-lg mb-8 max-w-xl mx-auto">
        Mit Datum, Ort und gewünschter Ausstattung – wir erstellen dir ein individuelles Angebot für Firmenfeiern, Hochzeiten und regionale Events.
      </p>
      <Button as="router-link" to="/shop/request" class="px-8">Zum Anfrageformular</Button>
    </div>

    <!-- Karte -->
    <div class="public-quiet-section bg-zinc-800 py-16 px-6">
      <div class="max-w-4xl mx-auto">
        <h2 class="text-3xl font-semibold text-white mb-6">Unser Standort</h2>
        <div class="rounded-xl overflow-hidden h-[400px]">
          <iframe
            title="Standort von Mody Veranstaltungstechnik in Flachau"
            width="100%"
            height="100%"
            style="border:0"
            loading="lazy"
            allowfullscreen
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBaypk5l3JpcJICotBRUhBFuBRWpp4_awA&q=place_id:ChIJ01pzNm7TdkcRdU073SXDXFg"
          ></iframe>
        </div>
      </div>
    </div>

  </main>
</template>

<style scoped lang="scss">
.contact-card{
  min-height: 88px;
  border: 1px solid $public-border;

  &:hover,
  &:focus-visible{
    border-color: rgba(213, 150, 69, 0.42);
  }
}
</style>
